// Helper for the Foundation 5 reveals, since the JS is 6 and styles a modified 5.5.3

export default function () {
    "use strict";

    let triggers = document.querySelectorAll('[data-open]');
    if (!triggers) {
        return false;
    }

    for (let i = 0; i < triggers.length; i++) {
        triggers[i].addEventListener('click', function (e) {
            e.preventDefault();

            let modal_id = this.getAttribute('data-open');
            console.log('modal_id: ', modal_id);

            if (!modal_id) {
                return;
            }

            let modal = document.getElementById(modal_id);
            console.log('modal: ', modal);

            if (!modal) {
                return;
            }
            // Forse aria-hidden to false.
            modal.setAttribute('aria-hidden', false);
        });
    }

    let closeBtns = document.querySelectorAll('[data-close]');
    if (!closeBtns) {
        return false;
    }

    for (let i = 0; i < closeBtns.length; i++) {
        closeBtns[i].addEventListener('click', function (e) {
            e.preventDefault();
            this.parentNode.setAttribute('aria-hidden', true);
        });
    }

};
